import { render, staticRenderFns } from "./bjlTable.vue?vue&type=template&id=1cef8c86&scoped=true"
import script from "./bjlTable.vue?vue&type=script&lang=ts"
export * from "./bjlTable.vue?vue&type=script&lang=ts"
import style0 from "./bjlTable.vue?vue&type=style&index=0&id=1cef8c86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cef8c86",
  null
  
)

export default component.exports